import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import './styles.css';

const NavSwitcher = props => {
  const handleClick = item => {
    props.onChange(item);
  };

  const items = useMemo(
    () =>
      props.items.map((item, index) => (
        <div key={index} className="nav-switcher__control">
          <div
            onClick={() => handleClick(item)}
            className={
              'nav-switcher__link' +
              (item.selected
                ? ' nav-switcher__link--selected'
                : item.disabled
                ? ' nav-switcher__link--disabled'
                : '')
            }
          >
            {item.title}
          </div>
        </div>
      )),
    [props.items]
  );

  return <div className="nav-switcher__control-wrapper">{items}</div>;
};

NavSwitcher.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
      selected: PropTypes.bool,
    })
  ),
  onChange: PropTypes.func.isRequired,
};

export default NavSwitcher;
